import { GF_EXP } from "./gf-exp.const";

export function getGFExp(): Uint8Array {
  return GF_EXP;
}
